/**
 * Handle articles social sharing options
 *
 * @param {string} toggleButtonSelector - selector for toggle button
 * @param {string} copyButtonSelector - selector for copy to clipboard button
 */

import { toggleIt } from './utils/showHide';
import { copyToClipboard } from './utils/copyToClipboard';

export const socialShare = (
    toggleButtonSelector = '#ghwp-social-share-toggle',
    copyButtonSelector = '#ghwp-social-share-copy'
) => {

    const socialShareToggle = document.querySelector(toggleButtonSelector);
    socialShareToggle &&
        socialShareToggle.addEventListener('click', function () {
            toggleIt(this);
        });

    const socialShareCopy = document.querySelector(copyButtonSelector);
    socialShareCopy &&
        socialShareCopy.addEventListener('click', function () {
            const articleUrl = socialShareCopy.getAttribute('data-article-url');
            copyToClipboard(articleUrl);
            socialShareCopy.firstElementChild.classList.add('copied');
        });
};
